/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Flex,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useAppSelector } from '../../../../redux/hooks';
import { setSelectRequestScreenClickedParamerterName } from '../../../../redux/manualVerification/sessionsDetails';
import { getSelectedManualVerificationSessionData } from '../../../../redux/manualVerification/sessionsDetails/selectors';

interface RequiredParametersTableProps {
  handleSearch: (searchString: string) => void;
}

export const RequiredParametersTable: React.FC<RequiredParametersTableProps> = ({
  handleSearch,
}) => {
  const selectedSessionData = useAppSelector(getSelectedManualVerificationSessionData);
  const dispatch = useDispatch();

  return (
    <>
      <Box w="100%">
        <Heading
          color="#000"
          pt={3}
          pb={1}
          px={4}
          textAlign="center"
          letterSpacing={0.5}
          className="medium-font"
        >
          Parameters to generate proof
        </Heading>
        <Box
          border="1.2px solid #D0D5DD"
          h="fit-content"
          borderRadius="12px"
          backgroundColor="transparent"
          overflow="hidden"
        >
          <Flex direction="column">
            <TableContainer>
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Td
                      textAlign="center"
                      border="1px solid"
                      borderColor="gray.200"
                      borderLeft="none"
                      borderTop="none"
                      w="35%"
                      p={3}
                    >
                      <Heading color="#000" fontWeight={500} className="small-font">
                        Name
                      </Heading>
                    </Td>
                    <Td
                      textAlign="center"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRight="none"
                      borderTop="none"
                      w="65%"
                    >
                      <Heading className="small-font" color="#000" fontWeight={500}>
                        Value
                      </Heading>
                    </Td>
                  </Tr>
                </Thead>
                <Tbody>
                  {selectedSessionData?.parameters?.length > 0 &&
                    selectedSessionData?.parameters?.map((param: any, index: number) => (
                      <Tr key={`${param?.key}_${param?.value}_${index}`}>
                        <Td
                          textAlign="center"
                          overflow="hidden"
                          whiteSpace="pre-wrap"
                          border="1px solid"
                          borderColor="gray.200"
                          borderLeft="none"
                          cursor="pointer"
                          _hover={{ fontWeight: 'bolder' }}
                          onClick={() => {
                            handleSearch(param?.key);
                            dispatch(
                              setSelectRequestScreenClickedParamerterName(param?.key)
                            );
                          }}
                        >
                          <Text
                            className="small-font"
                            color="#475467"
                            overflow="hidden"
                            whiteSpace="pre-wrap"
                          >
                            {param?.key}
                          </Text>
                        </Td>
                        <Td
                          textAlign="center"
                          overflow="hidden"
                          whiteSpace="pre-wrap"
                          borderColor="gray.200"
                          borderRight="none"
                          maxW="300px"
                          cursor="pointer"
                          _hover={{ fontWeight: 'bolder' }}
                          onClick={() => handleSearch(param?.value)}
                        >
                          <Flex alignItems="center">
                            <Text
                              className="small-font"
                              color="#475467"
                              whiteSpace="nowrap"
                              textOverflow="ellipsis"
                              overflow="hidden"
                              flex={1}
                            >
                              {param?.value}
                            </Text>
                          </Flex>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default RequiredParametersTable;
